import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance } from 'vue';
	import { mdiChevronDown, mdiChevronRight, mdiClose, mdiMenuDown } from '@mdi/js';
	import { VMenu } from 'vuetify/lib';

	import { externalLinks } from '@/constants/ameli';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'ameli-banner',
  setup(__props) {

	const baseAmeliUrl = 'https://www.ameli.fr';
	const baseAssuranceMaladieUrl = 'https://assurance-maladie.ameli.fr';
	const proSanteLinks = externalLinks.proSanteLinks;
	const assuranceMaladieLinks = externalLinks.assuranceMaladieLinks;

	let menuExpanded = false;

	/**
	 * Détermine si l'application est en vue mobile
	 */
	function isMobile(): boolean | undefined {
		return getCurrentInstance()?.proxy.$vuetify.breakpoint.smAndDown;
	}

	/**
	 * Switch pour la vue mobile ou laptop de la bannière
	 */
	function toggleMenu(): void {
		const content = document.getElementById('app-nav-bar-menu');

		if (!content) {
			return;
		}

		if (content.style.maxHeight) {
			content.style.removeProperty('max-height');
			menuExpanded = false;
			return;
		}

		content.style.maxHeight = content.scrollHeight + 'px';
		menuExpanded = true;
	}


return { __sfc: true,baseAmeliUrl, baseAssuranceMaladieUrl, proSanteLinks, assuranceMaladieLinks, menuExpanded, isMobile, toggleMenu, mdiChevronDown, mdiChevronRight, mdiClose, mdiMenuDown, VMenu }
}

})